<script>
  export let weaponIcon = "";
  export let weaponName = "";
  export let weaponPrice = 0;
  export let isSelected = false;
  export let isDisabled = false;
  export let onHover = () => {return () => {}};
  export let onClick = () => {};
  export let onRightClick = () => {};
  let onMouseLeave = () => {};
</script>

<button class={`weapon-item${isSelected ? ' selected' : ''}${isDisabled ? ' disabled' : ''}`}
  on:mouseenter={(e) => {
    onMouseLeave = onHover(e) || onMouseLeave;
  }}
  on:mouseleave={(e) => {
    onMouseLeave(e);
  }}
  on:click={onClick}
  on:contextmenu={onRightClick}
>
  <div class='left-container'>
    <img class="weapon-icon" src={weaponIcon} alt="Icon of weapon"/>
    <div class="weapon-name">{weaponName}</div>
  </div>
  <div class="weapon-price">€ {weaponPrice}</div>
</button>

<style>
  .left-container {
    display: grid;
  }

  .weapon-item {
    padding: 1.2em 1.2em;
    margin: 1px 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    text-align: left;
  }

  .weapon-item.selected {
    background: rgba(47, 47, 47, 0.75);
    border-left: 10px solid #22BA3A;
  }

  .weapon-item.disabled .weapon-name,
  .weapon-item.disabled .weapon-price {
    color: rgba(253, 253, 253, 0.35);
  }

  .weapon-item.disabled .weapon-icon {
    opacity: 0.35;
  }

  .weapon-icon {
    max-height: 50px;
    max-width: 150px;
  }

  .weapon-price {
    align-self: center;
    justify-self: flex-end;
  }
</style>